export enum SectionStatus {
  Pending,
  Initiated,
  Generated,
  InReview,
  Approved,
  Rejected,
  Failed,
}
